import { makeAutoObservable } from 'mobx'
import { type PageLayoutStore } from 'shared/layout'
import type { IEntitiesStore } from 'entities/EntitiesExport'

export class ClickToTextPageStore {
  private _isClickToTextActionShown = false
  private _isDetailsModalOpen = false

  constructor(private _pageLayoutStore: PageLayoutStore, private _entities: IEntitiesStore) {
    makeAutoObservable(this)
  }

  get isClickToTextActionShown() {
    return this._isClickToTextActionShown
  }

  get isDetailsModalOpen() {
    return this._isDetailsModalOpen
  }

  get pageLayoutStore() {
    return this._pageLayoutStore
  }

  get entities() {
    return this._entities
  }

  setIsClickToTextActionShown = (isClickToTextActionShown: boolean) => {
    this._isClickToTextActionShown = isClickToTextActionShown
  }

  setIsDetailsModalOpen = (isOpen: boolean) => {
    this._isDetailsModalOpen = isOpen
  }
}
